import styled from "styled-components"

import { eq, minWidth, when } from "utils"

export const Wrapper = styled.div`
  position: relative;
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem;
  overflow: hidden;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 100%;
  `}

  ${eq("priority", 1)`
    padding: 0 0 4rem 0;
  `}

  ${eq("priority", 2)`
    padding: 0 4rem 6rem 4rem;
  `}

  ${eq("priority", 3)`
    padding-bottom: 2rem;

    ${minWidth.hamburgerLarge`
      max-width: 35rem;
      margin-left: calc((100% - 72.5rem) / 2);
      padding: 0 2rem 3rem 0;
      float: left;
      ${when("isPremium")`
        max-width: 89rem;
        font-size: 2.8rem;
        padding: 1rem 13.3rem;
        float: none;
      `}
    `}
  `}
`

export const InnerWrapper = styled.div`
  ${eq("priority", 2)`
    ${minWidth.hamburgerLarge`
      max-width: 100%;
      padding: 2rem 0;
    `}
  `}
`

export const Quote = styled.blockquote`
  margin: 0;
  padding: 0;
`

export const Text = styled.p`
  position: relative;
  z-index: 4;
  margin: 0 0 2rem;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3rem;
  line-height: 3.9rem;
  color: #b5471f;
  ${minWidth.desktop`
    padding-right: 13rem;
  `}
  &:before {
    content: "“";
  }

  &:after {
    content: "”";
  }

  ${eq("priority", 1)`
    margin-bottom: 2rem;
    font-size: 4rem;
    line-height: 1.15;
    color: ${({ theme }) => theme.colors.text.primary};

    ${minWidth.tablet`
      font-size: 7rem;
    `}

    ${minWidth.hamburgerLarge`
      font-size: 13rem;
      margin-bottom: 4rem;
    `}
  `}

  ${eq("priority", 2)`
    font-size: 3rem;
    line-height: 1.3;

    ${minWidth.tablet`
      font-size: 3.5rem;
      line-height: 1.26;
    `}

    ${minWidth.hamburgerLarge`
      font-size: 4rem;
      line-height: 1.3;
    `}
  `}

  ${eq("priority", 3)`
    font-size: 2.3rem;
    line-height: 1.43;
    ${when("isPremium")`
      font-size: 2.2rem;
    `}

    ${minWidth.tablet`
      font-size: 2.6rem;
      line-height: 1.38;
    `}

    ${minWidth.hamburgerLarge`
      font-size: 2.2rem;
      line-height: 1.36;
      ${when("isPremium")`
        font-size: 2.8rem;
      `}
    `}
  `}
`

export const Attribution = styled.cite`
  position: relative;
  z-index: 4;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  font-style: normal;
  color: #767676;

  ${minWidth.tablet`
    font-size: 1.5rem;
  `}

  ${eq("priority", 1)`
    font-size: 1.8rem;
    line-height: 1.3;

    ${minWidth.tablet`
      font-size: 2rem;
    `}

    ${minWidth.hamburgerLarge`
      font-size: 2.3rem;
      line-height: 1.26;
    `}
  `}
`

export const Decoration = styled.div`
  position: absolute;
  z-index: 1;
  overflow: hidden;
  top: 18%;
  left: -2rem;
  transform: translateY(-25%);
  width: 17rem;
  height: 8.5rem;

  ${eq("priority", 2)`
    ${minWidth.tablet`
      left: -5rem;
    `}

    ${minWidth.hamburgerLarge`
      left: -11rem;
      width: 35rem;
      height: 17.5rem;
    `}
  `}
  ${minWidth.tablet`
    display: none;
  `}
`

export const DecorationCircle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-top: 100%;
  transform: rotate(135deg);
  border-radius: 50%;
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.15) 3px, transparent 1%);
  background-size: 8px 8px;
`
